import { declareString } from "@1js/localization";

export const TryThisPromptLabel = declareString(
  "promptLibrary.promptPreviewTryThisPromptLabel",
  {
    text: "Try this prompt",
    comment: "Label for the 'Try this prompt' title in the prompt details.",
  }
);
